import { ReactNode } from 'react';

import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import Menu from 'components/views/Menu';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const HeaderSubPages = ({ children }: { children: ReactNode }) => {
    return (
        <Menu>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <Box sx={{
                    display: 'flex',
                    gap: '.4375rem',
                    alignItems: 'flex-end',
                    marginBottom: {
                        xs: '0',
                        md: '1.64rem'
                    },
                    paddingBottom: '.56rem',
                    borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
                }}>
                    <Link to='/meus-veiculos'>
                        <Box sx={{
                            width: '1.5rem',
                            height: '1.5rem',
                            borderRadius: '2px',
                            display: 'flex',
                            padding: '.15rem 0',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid #0C1C33',
                            'svg': {
                                fill: '#0C1C33'
                            }
                        }}>
                            <ArrowBackIosNewIcon sx={{
                                height: '100%'
                            }} />
                        </Box>
                    </Link>
                    <Typography fontSize='1.25rem' fontWeight={700} color='primary.main' lineHeight='1'>
                        Meus veículos
                    </Typography>
                </Box>
                {children}
            </Box>
        </Menu>
    );
}

export default HeaderSubPages;